export default "__VITE_ASSET__Cnf_PeNw__"